import portfolio from "../../../../../public/lottie/portfolio.json";
import NotiFooter from "components/layouts/m/Footer/noti";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";

import Lottie from "lottie-react";
import useIsMobile from "states/deviceState";
import Button from "components/common/buttons/buttons";
function NoPort({ session }: { session: any }) {
  const { t } = useTranslation("portfolio");
  const router = useRouter();
  const RiskLevel =
    router.locale === "ko" ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="121"
        height="110"
        viewBox="0 0 121 110"
        fill="none"
      >
        <path
          d="M20.407 100.093C19.1183 101.382 17.0214 101.388 15.8054 100.03C8.65028 92.0412 3.75297 82.2633 1.65288 71.7054C-0.662234 60.0666 0.525968 48.0026 5.06723 37.039C9.60848 26.0754 17.2988 16.7047 27.1658 10.1118C37.0327 3.51894 48.6331 -2.41053e-06 60.5 -2.62268e-06C72.3669 -2.83483e-06 83.9673 3.51894 93.8342 10.1118C103.701 16.7047 111.392 26.0754 115.933 37.039C120.474 48.0026 121.662 60.0666 119.347 71.7054C117.247 82.2633 112.35 92.0412 105.195 100.03C103.979 101.388 101.882 101.382 100.593 100.093C99.3042 98.8042 99.3128 96.7212 100.52 95.3553C106.756 88.2958 111.029 79.6952 112.874 70.4178C114.934 60.0592 113.877 49.3223 109.835 39.5647C105.793 29.8071 98.949 21.4672 90.1674 15.5995C81.3859 9.73185 71.0615 6.6 60.5 6.6C49.9385 6.6 39.6141 9.73185 30.8325 15.5995C22.051 21.4672 15.2065 29.8071 11.1648 39.5647C7.12311 49.3223 6.06562 60.0592 8.12607 70.4178C9.97144 79.6951 14.2436 88.2958 20.4805 95.3553C21.6872 96.7212 21.6958 98.8042 20.407 100.093Z"
          fill="#DAE1E9"
        />
        <path
          d="M20.407 100.093C19.1183 101.382 17.0213 101.388 15.8054 100.03C10.2394 93.8153 6.02213 86.4984 3.4366 78.541C0.51064 69.5358 -0.242526 59.966 1.2387 50.6139C2.71992 41.2619 6.39346 32.3932 11.959 24.7329C16.8769 17.9639 23.1488 12.3083 30.3628 8.11789C31.9388 7.20246 33.9313 7.85603 34.7587 9.47992C35.5862 11.1038 34.9344 13.0822 33.3647 14.0083C27.0758 17.7187 21.6041 22.686 17.2985 28.6123C12.3452 35.4299 9.07573 43.3231 7.75744 51.6464C6.43916 59.9697 7.10947 68.4869 9.71358 76.5015C11.9772 83.4682 15.6461 89.8832 20.4806 95.3554C21.6872 96.7213 21.6958 98.8042 20.407 100.093Z"
          fill="url(#paint0_linear_10887_33268)"
        />
        <path
          d="M92.0322 42.7121H93.902V43.8464H81.8906V42.7121H90.6648C90.9807 41.2049 90.9963 40.1016 90.9963 39.1382H83.3927V38.0039H92.3792V38.9984C92.3792 39.9929 92.3792 41.122 92.0322 42.7121ZM84.7808 46.545H90.9756V44.9186H92.3533V50.3831H83.4082V44.9186H84.7808V46.545ZM84.7808 49.2487H90.9756V47.6275H84.7808V49.2487Z"
          fill="#647A90"
        />
        <path
          d="M71.7953 41.3234H79.5076V42.4474H70.4175V37.8945H79.4299V39.0289H71.7953V41.3234ZM68.9258 44.7367V43.5869H80.9061V44.7367H68.9258ZM74.8926 45.7623C77.7207 45.7623 79.4196 46.6221 79.4299 48.1449C79.4196 49.6728 77.7207 50.5275 74.8926 50.5275C72.0491 50.5275 70.3398 49.6728 70.3398 48.1449C70.3398 46.6221 72.0491 45.7623 74.8926 45.7623ZM74.8926 49.4449C76.8764 49.4449 78.0314 48.9891 78.0418 48.1449C78.0314 47.311 76.8764 46.8448 74.8926 46.8344C72.8881 46.8448 71.7435 47.311 71.7538 48.1449C71.7435 48.9891 72.8881 49.4449 74.8926 49.4449Z"
          fill="#647A90"
        />
        <path
          d="M53.3471 42.6596L61.4686 42.3437C61.4997 41.6393 61.4997 40.9711 61.5049 40.2977V39.8419H53.7148V38.6973H62.8619V40.2977C62.8619 42.2194 62.8619 44.0167 62.2921 46.7359L60.904 46.6116C61.1837 45.41 61.3287 44.3585 61.4064 43.3848L53.5335 43.794L53.3471 42.6596ZM52.3008 48.7922V47.6424H64.2656V48.7922H52.3008Z"
          fill="#647A90"
        />
        <path
          d="M45.2769 41.3858C44.4119 43.2194 42.4903 44.5972 40.3874 45.0582L39.7658 43.8979C42.2624 43.4318 44.5259 41.4221 44.5362 39.2881V38.2988H46.002V39.2881C46.002 41.4221 48.2759 43.4473 50.7931 43.8979L50.1612 45.0582C48.0583 44.6023 46.1315 43.2298 45.2769 41.3858ZM39.3359 48.8237V47.6686H51.3473V48.8237H39.3359Z"
          fill="#647A90"
        />
        <path
          d="M35.8822 50.5747V37.4238H37.2599V50.5747H35.8822ZM28.5428 43.4062V46.2757C30.6664 46.2653 32.5258 46.1669 34.722 45.8044L34.8515 46.9542C32.5258 47.3375 30.5472 47.4256 28.2372 47.4256H27.1132V42.2874H31.837V39.7443H27.0977V38.6048H33.2458V43.4062H28.5428Z"
          fill="#647A90"
        />
        <path
          d="M74.5877 70.1799H71.616V69.9465C71.634 66.7055 72.5497 65.7179 74.1388 64.7213C75.2341 64.039 76.0601 63.1861 76.0601 61.9202C76.0601 60.4927 74.9558 59.586 73.5732 59.586C72.3073 59.586 71.0863 60.394 70.9965 62.0818H67.8184C67.9171 58.6792 70.4579 56.9375 73.5911 56.9375C77.0117 56.9375 79.3729 58.8498 79.3729 61.8664C79.3729 63.9313 78.3405 65.278 76.6975 66.2655C75.2251 67.1544 74.6146 68.0342 74.5877 69.9465V70.1799ZM73.1782 75.7731C72.0918 75.7731 71.194 74.8933 71.212 73.807C71.194 72.7296 72.0918 71.8588 73.1782 71.8588C74.2376 71.8588 75.1353 72.7296 75.1443 73.807C75.1353 74.8933 74.2376 75.7731 73.1782 75.7731Z"
          fill="url(#paint1_linear_10887_33268)"
        />
        <path
          d="M61.1053 70.1799H58.1336V69.9465C58.1515 66.7055 59.0673 65.7179 60.6564 64.7213C61.7517 64.039 62.5777 63.1861 62.5777 61.9202C62.5777 60.4927 61.4734 59.586 60.0908 59.586C58.8249 59.586 57.6039 60.394 57.5141 62.0818H54.3359C54.4347 58.6792 56.9754 56.9375 60.1087 56.9375C63.5293 56.9375 65.8905 58.8498 65.8905 61.8664C65.8905 63.9313 64.858 65.278 63.2151 66.2655C61.7427 67.1544 61.1322 68.0342 61.1053 69.9465V70.1799ZM59.6957 75.7731C58.6094 75.7731 57.7116 74.8933 57.7296 73.807C57.7116 72.7296 58.6094 71.8588 59.6957 71.8588C60.7551 71.8588 61.6529 72.7296 61.6619 73.807C61.6529 74.8933 60.7551 75.7731 59.6957 75.7731Z"
          fill="url(#paint2_linear_10887_33268)"
        />
        <path
          d="M47.6229 70.1799H44.6512V69.9465C44.6691 66.7055 45.5849 65.7179 47.174 64.7213C48.2693 64.039 49.0952 63.1861 49.0952 61.9202C49.0952 60.4927 47.9909 59.586 46.6084 59.586C45.3425 59.586 44.1215 60.394 44.0317 62.0818H40.8535C40.9523 58.6792 43.493 56.9375 46.6263 56.9375C50.0469 56.9375 52.4081 58.8498 52.4081 61.8664C52.4081 63.9313 51.3756 65.278 49.7327 66.2655C48.2603 67.1544 47.6498 68.0342 47.6229 69.9465V70.1799ZM46.2133 75.7731C45.127 75.7731 44.2292 74.8933 44.2472 73.807C44.2292 72.7296 45.127 71.8588 46.2133 71.8588C47.2727 71.8588 48.1705 72.7296 48.1795 73.807C48.1705 74.8933 47.2727 75.7731 46.2133 75.7731Z"
          fill="url(#paint3_linear_10887_33268)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_10887_33268"
            x1="60.5"
            y1="-7.5"
            x2="60.5"
            y2="104.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#176CFF" />
            <stop offset="1" stopColor="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_10887_33268"
            x1="40.0006"
            y1="66.5756"
            x2="81.0006"
            y2="66.5756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#176CFF" />
            <stop offset="1" stopColor="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_10887_33268"
            x1="40.0006"
            y1="66.5756"
            x2="81.0006"
            y2="66.5756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#176CFF" />
            <stop offset="1" stopColor="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_10887_33268"
            x1="40.0006"
            y1="66.5756"
            x2="81.0006"
            y2="66.5756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#176CFF" />
            <stop offset="1" stopColor="#9C1EFF" />
          </linearGradient>
        </defs>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="121"
        height="120"
        viewBox="0 0 121 120"
        fill="none"
      >
        <path
          d="M20.407 100.093C19.1183 101.382 17.0213 101.388 15.8054 100.03C8.65025 92.0412 3.75294 82.2633 1.65285 71.7054C-0.662264 60.0666 0.525937 48.0026 5.06719 37.039C9.60845 26.0754 17.2988 16.7047 27.1658 10.1118C37.0327 3.51894 48.6331 2.12149e-07 60.5 0C72.3668 -2.12149e-07 83.9672 3.51894 93.8342 10.1118C103.701 16.7047 111.391 26.0754 115.933 37.039C120.474 48.0026 121.662 60.0666 119.347 71.7054C117.247 82.2633 112.35 92.0412 105.195 100.03C103.979 101.388 101.882 101.382 100.593 100.093C99.3042 98.8042 99.3128 96.7212 100.519 95.3553C106.756 88.2958 111.029 79.6952 112.874 70.4178C114.934 60.0592 113.877 49.3223 109.835 39.5647C105.793 29.8071 98.949 21.4672 90.1674 15.5995C81.3858 9.73186 71.0615 6.6 60.5 6.6C49.9384 6.6 39.6141 9.73186 30.8325 15.5995C22.0509 21.4672 15.2065 29.8071 11.1648 39.5647C7.12308 49.3223 6.06558 60.0592 8.12603 70.4178C9.97141 79.6952 14.2436 88.2958 20.4804 95.3553C21.6871 96.7212 21.6957 98.8042 20.407 100.093Z"
          fill="#DAE1E9"
        />
        <path
          d="M20.407 100.093C19.1183 101.382 17.0213 101.388 15.8054 100.03C10.2394 93.8153 6.02212 86.4984 3.4366 78.541C0.510634 69.5358 -0.242525 59.966 1.2387 50.6139C2.71992 41.2619 6.39346 32.3932 11.959 24.7329C16.8769 17.9639 23.1488 12.3083 30.3628 8.11789C31.9388 7.20246 33.9313 7.85603 34.7587 9.47993C35.5862 11.1038 34.9344 13.0822 33.3647 14.0083C27.0758 17.7188 21.6041 22.6861 17.2985 28.6123C12.3452 35.4299 9.07573 43.3231 7.75744 51.6464C6.43915 59.9697 7.10947 68.4869 9.71358 76.5015C11.9772 83.4682 15.646 89.8831 20.4804 95.3553C21.6871 96.7212 21.6957 98.8042 20.407 100.093Z"
          fill="url(#paint0_linear_11976_56805)"
        />
        <path d="M93.4434 38.3945V49H91.876V38.3945H93.4434Z" fill="#647A90" />
        <path
          d="M86.8955 49.1611C84.5518 49.1611 83.1162 47.5498 83.1162 45.0742C83.1162 42.6279 84.5811 40.9434 86.793 40.9434C88.6094 40.9434 90.3232 42.0713 90.3232 44.9424V45.499H84.6689C84.7129 47.0078 85.5991 47.8721 86.9102 47.8721C87.8037 47.8721 88.375 47.4912 88.6387 47.0078H90.2207C89.8691 48.2969 88.6387 49.1611 86.8955 49.1611ZM84.6836 44.3272H88.7852C88.7852 43.1113 88.0088 42.2324 86.8076 42.2324C85.5552 42.2324 84.7422 43.1992 84.6836 44.3272Z"
          fill="#647A90"
        />
        <path
          d="M82.4717 41.0459L79.5859 49H77.9014L75.0156 41.0459H76.7002L78.707 47.1543H78.7803L80.7871 41.0459H82.4717Z"
          fill="#647A90"
        />
        <path
          d="M70.9141 49.1611C68.5703 49.1611 67.1348 47.5498 67.1348 45.0742C67.1348 42.6279 68.5996 40.9434 70.8115 40.9434C72.6279 40.9434 74.3418 42.0713 74.3418 44.9424V45.499H68.6875C68.7314 47.0078 69.6177 47.8721 70.9287 47.8721C71.8223 47.8721 72.3936 47.4912 72.6572 47.0078H74.2393C73.8877 48.2969 72.6572 49.1611 70.9141 49.1611ZM68.7021 44.3272H72.8037C72.8037 43.1113 72.0273 42.2324 70.8262 42.2324C69.5737 42.2324 68.7607 43.1992 68.7021 44.3272Z"
          fill="#647A90"
        />
        <path
          d="M59.5615 49V38.3945H61.1728V47.6084H65.9629V49H59.5615Z"
          fill="#647A90"
        />
        <path
          d="M47.8135 49V38.3945H49.3809V44.4004H49.5127L52.6621 41.0459H54.5371L51.3291 44.459L54.7568 49H52.8379L50.1426 45.4258L49.3809 46.1729V49H47.8135Z"
          fill="#647A90"
        />
        <path
          d="M44.6348 43.2139C44.4883 42.584 43.9902 42.1738 43.126 42.1738C42.2324 42.1738 41.5879 42.6426 41.6025 43.2432C41.5879 43.7119 41.9687 44.0488 42.8477 44.2539L44.1074 44.5469C45.5723 44.8691 46.2754 45.5723 46.29 46.7002C46.2754 48.1357 45.0742 49.1611 43.0381 49.1611C41.1338 49.1611 39.9912 48.3115 39.8008 46.832H41.3975C41.5293 47.5498 42.0859 47.9014 43.0234 47.9014C44.0342 47.9014 44.6787 47.4912 44.6934 46.8174C44.6787 46.3047 44.2978 45.9678 43.4629 45.7773L42.2178 45.5137C40.7822 45.1914 40.0352 44.4297 40.0352 43.3311C40.0352 41.9102 41.2656 40.9434 43.1113 40.9434C44.8838 40.9434 45.9824 41.8516 46.1436 43.2139H44.6348Z"
          fill="#647A90"
        />
        <path
          d="M36.6953 49V41.0459H38.2627V49H36.6953ZM37.4863 39.8154C36.9443 39.8154 36.4902 39.4053 36.4902 38.8926C36.4902 38.3799 36.9443 37.9697 37.4863 37.9697C38.0137 37.9697 38.4678 38.3799 38.4678 38.8926C38.4678 39.4053 38.0137 39.8154 37.4863 39.8154Z"
          fill="#647A90"
        />
        <path
          d="M27.584 49V38.3945H31.3633C33.8242 38.3945 35.04 39.7715 35.04 41.7197C35.04 43.148 34.3955 44.2319 33.1064 44.708L35.4502 49H33.6191L31.4658 45.001H29.1953V49H27.584ZM29.1953 43.6094H31.2021C32.7695 43.6094 33.4141 42.9209 33.4141 41.7197C33.4141 40.5186 32.7695 39.7715 31.2021 39.7715H29.1953V43.6094Z"
          fill="#647A90"
        />
        <path
          d="M74.5871 75.6043H71.6154V75.3709C71.6334 72.1298 72.5491 71.1423 74.1382 70.1457C75.2335 69.4634 76.0595 68.6105 76.0595 67.3446C76.0595 65.9171 74.9552 65.0104 73.5726 65.0104C72.3067 65.0104 71.0857 65.8184 70.9959 67.5062H67.8177C67.9165 64.1036 70.4573 62.3619 73.5905 62.3619C77.0111 62.3619 79.3723 64.2742 79.3723 67.2907C79.3723 69.3557 78.3398 70.7023 76.6969 71.6899C75.2245 72.5787 74.614 73.4586 74.5871 75.3709V75.6043ZM73.1776 81.1975C72.0912 81.1975 71.1934 80.3177 71.2114 79.2314C71.1934 78.154 72.0912 77.2831 73.1776 77.2831C74.2369 77.2831 75.1347 78.154 75.1437 79.2314C75.1347 80.3177 74.2369 81.1975 73.1776 81.1975Z"
          fill="url(#paint1_linear_11976_56805)"
        />
        <path
          d="M61.1047 75.6043H58.133V75.3709C58.1509 72.1298 59.0667 71.1423 60.6558 70.1457C61.7511 69.4634 62.577 68.6105 62.577 67.3446C62.577 65.9171 61.4727 65.0104 60.0902 65.0104C58.8243 65.0104 57.6033 65.8184 57.5135 67.5062H54.3353C54.4341 64.1036 56.9748 62.3619 60.1081 62.3619C63.5287 62.3619 65.8899 64.2742 65.8899 67.2907C65.8899 69.3557 64.8574 70.7023 63.2145 71.6899C61.7421 72.5787 61.1316 73.4586 61.1047 75.3709V75.6043ZM59.6951 81.1975C58.6088 81.1975 57.711 80.3177 57.729 79.2314C57.711 78.154 58.6088 77.2831 59.6951 77.2831C60.7545 77.2831 61.6523 78.154 61.6613 79.2314C61.6523 80.3177 60.7545 81.1975 59.6951 81.1975Z"
          fill="url(#paint2_linear_11976_56805)"
        />
        <path
          d="M47.6222 75.6043H44.6506V75.3709C44.6685 72.1298 45.5843 71.1423 47.1733 70.1457C48.2686 69.4634 49.0946 68.6105 49.0946 67.3446C49.0946 65.9171 47.9903 65.0104 46.6077 65.0104C45.3418 65.0104 44.1209 65.8184 44.0311 67.5062H40.8529C40.9517 64.1036 43.4924 62.3619 46.6257 62.3619C50.0463 62.3619 52.4075 64.2742 52.4075 67.2907C52.4075 69.3557 51.375 70.7023 49.732 71.6899C48.2597 72.5787 47.6492 73.4586 47.6222 75.3709V75.6043ZM46.2127 81.1975C45.1264 81.1975 44.2286 80.3177 44.2465 79.2314C44.2286 78.154 45.1264 77.2831 46.2127 77.2831C47.2721 77.2831 48.1699 78.154 48.1789 79.2314C48.1699 80.3177 47.2721 81.1975 46.2127 81.1975Z"
          fill="url(#paint3_linear_11976_56805)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11976_56805"
            x1="-19.0402"
            y1="-74.0867"
            x2="124.93"
            y2="-74.0867"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#176CFF" />
            <stop offset="1" stop-color="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_11976_56805"
            x1="-288.402"
            y1="51.7089"
            x2="137.404"
            y2="51.7089"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#176CFF" />
            <stop offset="1" stop-color="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_11976_56805"
            x1="-148.38"
            y1="51.7089"
            x2="277.426"
            y2="51.7089"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#176CFF" />
            <stop offset="1" stop-color="#9C1EFF" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_11976_56805"
            x1="40"
            y1="71.9995"
            x2="81"
            y2="71.9995"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#176CFF" />
            <stop offset="1" stop-color="#9C1EFF" />
          </linearGradient>
        </defs>
      </svg>
    );

  const rebalanceRisk = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6641 34.3082C14.6641 32.3905 16.2186 30.8359 18.1363 30.8359H36.1918C38.1095 30.8359 39.6641 32.3905 39.6641 34.3082V50.2804C39.6641 52.198 41.2186 53.7526 43.1363 53.7526H59.1085C61.0262 53.7526 62.5807 55.3072 62.5807 57.2248V71.1137C62.5807 73.0314 64.1353 74.5859 66.053 74.5859H82.0252C83.9428 74.5859 85.4974 76.1405 85.4974 78.0582V98.1971C85.4974 100.115 83.9428 101.669 82.0252 101.669H28.553C20.8823 101.669 14.6641 95.451 14.6641 87.7804V34.3082Z"
        fill="#34BB7A"
      />
      <path
        d="M27.1641 21.1162C38.4141 6.22211 49.6641 16.8553 49.6641 38.1307C57.1641 22.079 75.9141 24.4065 75.9141 63.6483C87.1641 43.5773 102.164 50.8867 102.164 89.1719"
        stroke="url(#paint0_linear_10788_45825)"
        strokeWidth="6.94444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.8358 80.7999L102.675 89.6387L112.028 81.3467"
        stroke="#185538"
        strokeWidth="6.94444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10788_45825"
          x1="64.6641"
          y1="14.1719"
          x2="64.6641"
          y2="89.1719"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.335" stopColor="#34BB7A" />
          <stop offset="1" stopColor="#185538" />
        </linearGradient>
      </defs>
    </svg>
  );

  const comparePort = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
    >
      <rect
        x="26.668"
        y="18.3359"
        width="58.3333"
        height="75"
        rx="2.17014"
        fill="#75A7FF"
      />
      <path
        d="M41.7734 36.1291C41.7734 34.9306 42.745 33.959 43.9436 33.959L96.895 33.959C98.0935 33.959 99.0651 34.9306 99.0651 36.1291V86.0423L78.2318 106.876H43.9436C42.745 106.876 41.7734 105.904 41.7734 104.705V36.1291Z"
        fill="#1A6DFF"
      />
      <path
        d="M78.2305 87.781C78.2305 86.8222 79.0078 86.0449 79.9666 86.0449H99.0638L88.6471 96.4616L78.2305 106.878V87.781Z"
        fill="#7AADFF"
      />
      <circle
        cx="19.2"
        cy="19.2"
        r="19.2"
        transform="matrix(-1 0 0 1 55.8008 45.5996)"
        fill="white"
        fillOpacity="0.61"
        stroke="black"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2012 79.1992L7.80117 93.5992"
        stroke="black"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const isMobile = useIsMobile();
  return (
    <>
      <div className="flex flex-col relative px-6 w-full pb-10">
        <div className="mt-9  flex flex-col gap-4 p-5 rounded-[24px] bg-blue5">
          <div className="flex flex-col justify-center items-center text-center gap-1">
            <span className={`${TYPO.TYPO7_MD} text-gray70`}>
              {router.locale === "ko"
                ? "리스크웨더 포트폴리오"
                : "Riskweather Portfolio"}
            </span>
            <span
              className={`${TYPO.TYPO3_SB} text-gray80 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? `잃지 않는 투자 \n 포트폴리오 리스크 진단부터`
                : "Focus on Risk for\n No-Loss Investment."}
            </span>
          </div>
          <div className="flex justify-center items-center">
            <Lottie
              animationData={portfolio}
              renderer="svg"
              autoplay
              loop
              // style={{ width: 7, height: 7 }}
            />
          </div>

          <Button
            type={"primary"}
            size={"lg"}
            text={
              router.locale === "ko"
                ? "포트폴리오에 내 자산 등록하기"
                : "Add Assets to Portfolio"
            }
            width="w-full"
            clickHandler={() => {
              if (!session) {
                router.push("/login");
              } else {
                router.push("/portfolio/new");
              }
            }}
          />
        </div>
        {/* <div className="py-5 flex justify-center ">
          <Lottie
            animationData={learnLottie}
            renderer="svg"
            autoplay
            loop
            // style={{ width: 7, height: 7 }}
          />
        </div> */}
        <div className="pt-9 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <span
              className={`${TYPO.TYPO4_SB} text-gray80 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? "내 포트폴리오 리스크 \n 등급별로 진단해요"
                : "Diagnose the Risk Level of\n My Portfolio"}
            </span>
            <span className={`${TYPO.TYPO6_RG} text-gray60`}>
              {router.locale === "ko"
                ? "투자 리스크 정도를 위험/주의/적정/안전 4단계로 쉽게 알려드려요."
                : "Easily understand the level of \n investment risk in 4 stages."}
            </span>
          </div>
          <div className="flex justify-center p-[30px]">{RiskLevel}</div>
        </div>
        <div className="pt-9 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <span
              className={`${TYPO.TYPO4_SB} text-gray80 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? "버튼 한 번으로 내려가는\n 내 포트폴리오 리스크"
                : "Lowering My Portfolio Risk with One Click"}
            </span>
            <span
              className={`${TYPO.TYPO6_RG} text-gray60 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? "감당할 수 없는 리스크라면\n버튼 한 번으로 낮출 수 있어요."
                : "If the risk is unbearable,\nyou can lower it with just one click."}
            </span>
          </div>
          <div className="flex justify-center p-[30px]">{rebalanceRisk}</div>
        </div>
        <div className="pt-9 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <span
              className={`${TYPO.TYPO4_SB} text-gray80 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? "비슷한 투자자와\n포트폴리오 비교해요"
                : "Compare Your Portfolio with Similar Investors"}
            </span>
            <span
              className={`${TYPO.TYPO6_RG} text-gray60 whitespace-pre-line`}
            >
              {router.locale === "ko"
                ? "다른 투자자와 리스크 비교는 물론\n 많이 보유한 종목까지 볼 수 있어요"
                : "Not only compare risks but also\n see the stocks they hold the most."}
            </span>
          </div>
          <div className="flex justify-center p-[30px]">{comparePort}</div>
        </div>
      </div>

      <NotiFooter />
    </>
  );
}

export default NoPort;
